/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import { Navigate } from 'react-router-dom';
import {
  GreyBackgroundWithCenteredChildren,
  PaperWithForm,
} from '../components/PaperOnCenter';
import { useChangePassword, NewPassword } from './UserManagement';

export default function ConfirmResetPassword() {
  return (
    <GreyBackgroundWithCenteredChildren>
      <PaperWithForm
        Title="New password"
        Form={
          <NewPassword
            mutation={useChangePassword}
            SuccessComponent={<Navigate to="/" />}
          />
        }
      />
    </GreyBackgroundWithCenteredChildren>
  );
}
